import React, { useContext, useEffect } from "react";
import { apiUrl } from "../../../Constants/Constants";
import { AuthContext } from "../../../Constants/AuthProvider";
import { useFetchWithToken } from "./../../FetchWithToken/FetchWithToken";
import { ConfirmationModalContext } from "../../../fautures/ConfirmationModalProvider";
import { toast } from "react-toastify";
import styles from "./InternalIPs.module.css";
const InternalIPs = ({ item }) => {
  const EachIp = ({ ips }) => {
    return (
      <div className={styles.ips}>
        <i class="fa-regular fa-network-wired"></i> {ips}
      </div>
    );
  };
  return (
    <>
      {item?.contain?.activeLocalIps?.length !== 0 && (
        <div className={styles.userActions}>
          <div className={`${styles.label} ${styles.fuller} `}>
            <div className={styles.mkcol2}>
              <div>
                <i class="fa-solid fa-server"></i>
                آیپی های داخلی سرور
              </div>
            </div>
            <div className={styles.downpartdesc}>
              <div className={styles.ipContainer}>
                {item?.contain?.activeLocalIps?.length !== 0 ? (
                  <>
                    {item?.contain?.activeLocalIps?.map((ips) => (
                      <EachIp ips={ips} />
                    ))}
                  </>
                ) : (
                  <div className={styles.noIP}>
                    پس از اولین اتصال، آی‌پی شما به‌صورت خودکار اینجا نشان داده
                    می‌شود.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InternalIPs;
